// Helpers since date-fns doesn't consider local timezone

import { toZonedTime } from 'date-fns-tz';

/** Converts the given UTC date to a date in the specified timezone, suitable for passing to date-fns */
export function localDate(date) {
  return toZonedTime(new Date(date), Intl.DateTimeFormat().resolvedOptions().timeZone);
};
